import { AmplitudeAnalytics } from "./amplitude";

export const analytics = new AmplitudeAnalytics(process.env.REACT_APP_AMPLITUDE_API_KEY!);